import styled from 'styled-components'

const CopyrightWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: column;
  background-color: ${({theme}) => theme.shell.footer.copyright.backgroundColor};
  border-top: ${({theme}) => theme.shell.footer.copyright.borderTop};
`
export default CopyrightWrapper
